import { Cart as Cart } from './Cart';

export default Cart;
